import Tabs from './TabsClient';
import { Screen } from '../views/Screen';

export * from '../react-navigation/bottom-tabs';

Tabs.Screen = Screen;

export { Tabs };

export default Tabs;
